// Deterministic color generation and contrast helper
export function colorFromString(str) {
  let hash = 0;
  if (!str) return 'hsl(200,65%,45%)';
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue},65%,45%)`;
}

// Given an HSL string like "hsl(123,65%,45%)" returns '#000' or '#fff' depending on lightness
export function textColorForHsl(hsl) {
  if (!hsl || typeof hsl !== 'string') return '#fff';
  const m = hsl.match(/hsl\(\s*\d+\s*,\s*\d+%\s*,\s*(\d+)%\s*\)/);
  if (!m) return '#fff';
  const lightness = parseInt(m[1], 10);
  // If lightness is high, use dark text
  return lightness > 60 ? '#000' : '#fff';
}

export function hslWithAlpha(hsl, alpha) {
  if (!hsl || typeof hsl !== 'string') return hsl;
  // convert 'hsl(h, s%, l%)' -> 'hsla(h, s%, l%, alpha)'
  const m = hsl.match(/hsl\((\s*\d+\s*),\s*(\d+)%\s*,\s*(\d+)%\s*\)/);
  if (!m) return hsl;
  const h = m[1].trim();
  const s = m[2].trim();
  const l = m[3].trim();
  return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
}

// Normalize keys so that equivalent exercise names map to the same color
export function normalizeKey(str) {
  if (str === undefined || str === null) return '';
  try {
    return String(str).trim().toLowerCase();
  } catch (e) {
    return String(str || '');
  }
}
